export enum REQUEST_TYPES {
	DO_ACTION_UPDATE_USER = 'DO_ACTION_UPDATE_USER',
}
